import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {
  InputTextWrapper,
  SelectWrapper,
  InputDateWrapper,
} from '../../../../../../components/UI/Form/Input'
import {ModalComponent} from '../../../../components/Modal'
import {startProcessWash} from '../../../../services'
import useTableForMaster from '../../../../hooks/useTableForMaster'
import usePointList from '../../../../hooks/usePoint'
import {Switch} from '../../../../../../components/UI/Switch'
import {ButtonWrapper, Button} from '../../../../../../components/UI/Button'
import moment from 'moment'
import {ShowSnackBar, confirmModal} from '../../../../../../util/functions'
import {SUCCESS_MESSAGE_CREATE} from '../../../../../../util/Constants'
import Swal from 'sweetalert2'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {yupResolver} from '@hookform/resolvers/yup'
import {processWashCBatch} from '../../../../schema/laundryBatch'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  data?: any[]
  tipoLavado?: string
}

const LavadoCompania: FC<Props> = ({show, setShow, data = [], tipoLavado}) => {
  const {changeCurrentTabItem, currentTabItem} = useLavanderia()
  const [searching, setIsSearching] = useState<boolean>(false)
  const methods = useForm({
    resolver: yupResolver(processWashCBatch),
  })

  const {
    setValue,
    handleSubmit,
    register,
    formState: {errors},
  } = methods
  const {washingPlace, getWashingPlaceList} = useTableForMaster()
  const {getPointList, pointList} = usePointList()
  const {data: dataTable, setUpdateTable} = useKTable()
  const onSubmit = async (dataForm: any) => {
    try {
      setIsSearching(true)
      let obj = {
        ...dataForm,
        TipoProceso: 'LAVADO',
        ordenIds: data,
        tipoLavado,
      }
      const result = await confirmModal({
        title: 'Esta seguro de generar Lote',
        bodyText: '',
        icon: 'warning',
        showCancelButton: true,
        textButtonCancel: 'No',
        textButtonConfirm: 'Sí',
      })
      if (result.isConfirmed) {
        const {data: response} = await startProcessWash(obj)
        if (!response.error) {
          ShowSnackBar(SUCCESS_MESSAGE_CREATE)
          setUpdateTable(true)
          setShow(false)
          // changeCurrentTabItem({
          //   ...currentTabItem,
          //   typeAdmin: '',
          //   typeProcess: '',
          // })
          Swal.close()
        } else {
          ShowSnackBar(response.message, 'error')
        }
      }
    } catch (error) {
      ShowSnackBar('ERROR DEL SISTEMA', 'error')
    }
  }
  useEffect(() => {
    getWashingPlaceList()
    const filteredData = dataTable.filter((item) => data.includes(item.id))
    let selectedItem = filteredData[0]
    let site = selectedItem.siteId
    getPointList({siteId: site})
    setValue('fechaRealLavado', moment().format('YYYY-MM-DD'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    setValue('countOrder', data.length)
    setValue('iniciarLavado', true)
    validatePoint()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  useEffect(() => {
    const value = washingPlace.filter((item) => item.codigo === 'LAVADO EN SITE')[0]?.label || ''
    setValue('lugarLavado', value)
  }, [washingPlace])

  const validatePoint = () => {
    const filteredData = dataTable.filter((item) => data.includes(item.id))
    let selectedItem = filteredData[0]
    let point = selectedItem.puntoId
    const isSamePoint = filteredData.every((item) => item.puntoId === point)
    if (isSamePoint) {
      setValue('puntoId', point)
    }
  }
  return (
    <ModalComponent
      show={show}
      setShow={setShow}
      title='GENERAR LOTE'
      type='modal'
      size='lg'
      showFooter={false}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className='m-2'>
          <div className='row'>
            <div className='col-sm-12 col-lg-5'>
              <InputTextWrapper
                labelText='Cantidad de Órdenes de Lavado'
                name='countOrder'
                disabled
              />
            </div>
          </div>
          <div className='row mb-4'>
            <div className='col-sm-12 col-lg-4'>
              <SelectWrapper
                labelText='Lugar de Lavado'
                name='lugarLavado'
                data={washingPlace}
                disabled
              />
            </div>
            <div className='col-sm-12 col-lg-4'>
              <SelectWrapper
                labelText='Punto de lavandería'
                name='puntoId'
                data={pointList}
                required
              />
            </div>

            <div className='col-sm-12 col-lg-4'>
              <InputDateWrapper
                labelText='Fecha Inicio real de lavado'
                name='fechaRealLavado'
                required
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-lg-6'>
              <label>Inicio de Lavado:</label>
              <Switch register={register} name='iniciarLavado' errors={errors} />
            </div>
          </div>
          <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
            <Button
              label='Generar Lote'
              typeBtn='submit'
              loading={searching}
              disabled={searching}
            />
          </ButtonWrapper>
        </form>
      </FormProvider>
    </ModalComponent>
  )
}

export {LavadoCompania}
